class Sky300VehicleFinder extends HTMLElement {
  connectedCallback() {
    this.options = Array.from(this.querySelectorAll('input[name^="sky300-vehicle-"]'));
    this.primaryButton = this.querySelector('[data-finder-submit]');
    this.helpLink = this.querySelector('[data-finder-help]');
    this.status = this.querySelector('[data-finder-status]');

    if (!this.options.length || !this.primaryButton) return;

    this.options.forEach((option) => {
      option.addEventListener('change', () => this.update(option));
    });

    this.primaryButton.addEventListener('click', (event) => {
      const selected = this.options.find((option) => option.checked);
      if (!selected) {
        event.preventDefault();
        if (this.status) {
          this.status.textContent = (this.dataset.language || 'es') === 'en'
            ? 'Choose your Mazda first. If it is not listed, ask us on WhatsApp.'
            : 'Primero elige tu Mazda. Si no aparece, pregúntanos por WhatsApp.';
        }
        this.options[0]?.focus();
        return;
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'sky300_finder_continue', vehicle: selected.dataset.vehicle });
    });
  }

  update(option) {
    const destination = option.dataset.url;
    const vehicle = option.dataset.vehicle;
    const language = this.dataset.language || 'es';

    if (!destination) return;

    const separator = destination.includes('?') ? '&' : '?';
    this.primaryButton.href = `${destination}${separator}utm_source=vehicle_finder&utm_medium=homepage&utm_campaign=compatible_products`;
    this.primaryButton.setAttribute('aria-disabled', 'false');

    if (this.status) {
      this.status.textContent = language === 'en'
        ? `${vehicle} selected. Continue to see products assigned to this platform and engine.`
        : `${vehicle} seleccionado. Continúa para ver los productos asignados a esta plataforma y motor.`;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'sky300_vehicle_selected', vehicle });

    if (this.helpLink) {
      const text = language === 'en'
        ? `Hello Sky300 Performance. I have a ${vehicle}. Year: ____. Engine: ____. I need help choosing this product or upgrade: ____.`
        : `Hola Sky300 Performance. Tengo un ${vehicle}. Año: ____. Motor: ____. Necesito ayuda para elegir este producto o mejora: ____.`;
      this.helpLink.href = `https://wa.me/573003586097?text=${encodeURIComponent(text)}`;
    }
  }
}

if (!customElements.get('sky300-vehicle-finder')) {
  customElements.define('sky300-vehicle-finder', Sky300VehicleFinder);
}
